var map = {
	".": "vVGz",
	"./": "vVGz",
	"./01_get_quote_contracts": "DcMO",
	"./01_get_quote_contracts.json": "DcMO",
	"./03_get_quote_depth": "e+0O",
	"./03_get_quote_depth.json": "e+0O",
	"./04_get_quote_ trades": "PqB/",
	"./04_get_quote_ trades.json": "PqB/",
	"./05_get_quote_ premiumIndex": "Tk4L",
	"./05_get_quote_ premiumIndex.json": "Tk4L",
	"./06_get_quote_ fundingRate": "YtyA",
	"./06_get_quote_ fundingRate.json": "YtyA",
	"./07_get_quote_ klines": "xU+M",
	"./07_get_quote_ klines.json": "xU+M",
	"./08_get_quote_openInterest": "j4uq",
	"./08_get_quote_openInterest.json": "j4uq",
	"./09_get_quote_ ticker": "LWb5",
	"./09_get_quote_ ticker.json": "LWb5",
	"./19_get_historicalTrades": "xyiP",
	"./19_get_historicalTrades.json": "xyiP",
	"./20_get_trade_quote_bookTicker": "E4EJ",
	"./20_get_trade_quote_bookTicker.json": "E4EJ",
	"./21_get_quote_mark_price_klines": "VeQG",
	"./21_get_quote_mark_price_klines.json": "VeQG",
	"./22_get_quote_price_v2": "rCcB",
	"./22_get_quote_price_v2.json": "rCcB",
	"./23_get_trading_rules": "fKSd",
	"./23_get_trading_rules.json": "fKSd",
	"./index": "vVGz",
	"./index.js": "vVGz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Dsow";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/market ^.*$
// module id = Dsow
// module chunks = 3